module.exports = __webpack_public_path__ + "static/media/training.9259dec6.svg";